export const ember = {
  '50': 'hsl(206.666667, 11.688312%, 15.098039%)',
  '100': 'hsl(212.903226, 35.632184%, 17.058824%)',
  '150': 'hsl(222.5, 46.153846%, 20.392157%)',
  '200': 'hsl(238.909091, 42.635659%, 25.294118%)',
  '250': 'hsl(256.438356, 54.074074%, 26.470588%)',
  '300': 'hsl(272.210526, 73.643411%, 25.294118%)',
  '350': 'hsl(288, 74.626866%, 26.27451%)',
  '400': 'hsl(306.902655, 79.020979%, 28.039216%)',
  '450': 'hsl(321.2, 89.285714%, 32.941176%)',
  '500': 'hsl(333.149171, 92.820513%, 38.235294%)',
  '550': 'hsl(348.556701, 82.20339%, 46.27451%)',
  '600': 'hsl(356.98324, 73.061224%, 51.960784%)',
  '650': 'hsl(4.285714, 77.118644%, 53.72549%)',
  '700': 'hsl(10.515464, 81.512605%, 53.333333%)',
  '750': 'hsl(15.512195, 85.774059%, 53.137255%)',
  '800': 'hsl(20, 90%, 52.941176%)',
  '850': 'hsl(27.935223, 100%, 48.431373%)',
  '900': 'hsl(31.325301, 100%, 48.823529%)',
  '950': 'hsl(34.661355, 100%, 49.215686%)',
  '1000': 'hsl(38.247012, 100%, 49.215686%)',
  '1050': 'hsl(41.632653, 96.078431%, 50%)',
}
export const earthfire = {
  '50': 'hsl(31.578947, 53.271028%, 20.980392%)',
  '100': 'hsl(30, 75.925926%, 21.176471%)',
  '150': 'hsl(28.333333, 100%, 21.176471%)',
  '200': 'hsl(22.622951, 100%, 23.921569%)',
  '250': 'hsl(16.888889, 100%, 26.470588%)',
  '300': 'hsl(10.945946, 100%, 29.019608%)',
  '350': 'hsl(13.703704, 94.186047%, 33.72549%)',
  '400': 'hsl(15.517241, 88.77551%, 38.431373%)',
  '450': 'hsl(17.005348, 84.615385%, 43.333333%)',
  '500': 'hsl(18.712871, 82.113821%, 48.235294%)',
  '550': 'hsl(20, 90%, 52.941176%)',
  '600': 'hsl(27.935223, 100%, 48.431373%)',
  '650': 'hsl(31.325301, 100%, 48.823529%)',
  '700': 'hsl(34.661355, 100%, 49.215686%)',
  '750': 'hsl(38.247012, 100%, 49.215686%)',
  '800': 'hsl(41.632653, 96.078431%, 50%)',
  '850': 'hsl(40.209424, 95.024876%, 60.588235%)',
  '900': 'hsl(41.226994, 94.219653%, 66.078431%)',
  '950': 'hsl(42.428571, 94.594595%, 70.980392%)',
  '1000': 'hsl(44.369748, 95.2%, 75.490196%)',
  '1050': 'hsl(46.666667, 96.116505%, 79.803922%)',
}
export const fuchsiaHeat = {
  '50': 'hsl(314.257426, 100%, 19.803922%)',
  '100': 'hsl(313.884298, 96.8%, 24.509804%)',
  '150': 'hsl(313.521127, 94.666667%, 29.411765%)',
  '200': 'hsl(313.416149, 90.960452%, 34.705882%)',
  '250': 'hsl(313.333333, 87.378641%, 40.392157%)',
  '300': 'hsl(312.964824, 84.680851%, 46.078431%)',
  '350': 'hsl(325.2, 80%, 50.980392%)',
  '400': 'hsl(337.230769, 86.666667%, 55.882353%)',
  '450': 'hsl(350.491803, 90.147783%, 60.196078%)',
  '500': 'hsl(5.869565, 91.089109%, 60.392157%)',
  '550': 'hsl(20, 90%, 52.941176%)',
  '600': 'hsl(27.935223, 100%, 48.431373%)',
  '650': 'hsl(31.325301, 100%, 48.823529%)',
  '700': 'hsl(34.661355, 100%, 49.215686%)',
  '750': 'hsl(38.247012, 100%, 49.215686%)',
  '800': 'hsl(41.632653, 96.078431%, 50%)',
  '850': 'hsl(40.209424, 95.024876%, 60.588235%)',
  '900': 'hsl(41.226994, 94.219653%, 66.078431%)',
  '950': 'hsl(42.428571, 94.594595%, 70.980392%)',
  '1000': 'hsl(44.369748, 95.2%, 75.490196%)',
  '1050': 'hsl(46.666667, 96.116505%, 79.803922%)',
}
export const polarGlow = {
  '50': 'hsl(217.2, 100%, 19.607843%)',
  '100': 'hsl(216.377953, 98.449612%, 25.294118%)',
  '150': 'hsl(216, 96.273292%, 31.568627%)',
  '200': 'hsl(216.263736, 92.857143%, 38.431373%)',
  '250': 'hsl(216.811594, 88.841202%, 45.686275%)',
  '300': 'hsl(217.339056, 98.312236%, 53.529412%)',
  '350': 'hsl(209.090909, 100%, 45.294118%)',
  '400': 'hsl(203.653846, 100%, 40.784314%)',
  '450': 'hsl(197.608696, 100%, 36.078431%)',
  '500': 'hsl(191.851852, 100%, 31.764706%)',
  '550': 'hsl(188.75, 51.06383%, 36.862745%)',
  '600': 'hsl(188.387097, 41.333333%, 44.117647%)',
  '650': 'hsl(188.478261, 36.8%, 50.980392%)',
  '700': 'hsl(187.333333, 42.056075%, 58.039216%)',
  '750': 'hsl(187.333333, 50.561798%, 65.098039%)',
  '800': 'hsl(186.741573, 63.120567%, 72.352941%)',
  '850': 'hsl(184.8, 59.055118%, 75.098039%)',
  '900': 'hsl(182, 53.571429%, 78.039216%)',
  '950': 'hsl(178.77551, 50.515464%, 80.980392%)',
  '1000': 'hsl(173.846154, 49.367089%, 84.509804%)',
  '1050': 'hsl(171.724138, 46.031746%, 87.647059%)',
}
export const glacierPool = {
  '50': 'hsl(272.210526, 73.643411%, 25.294118%)',
  '100': 'hsl(268.867925, 63.855422%, 32.54902%)',
  '150': 'hsl(265.423729, 57.843137%, 40%)',
  '200': 'hsl(262.615385, 53.278689%, 47.843137%)',
  '250': 'hsl(259.583333, 63.716814%, 55.686275%)',
  '300': 'hsl(256.538462, 84.782609%, 63.921569%)',
  '350': 'hsl(249.936306, 89.714286%, 65.686275%)',
  '400': 'hsl(242.307692, 93.975904%, 67.45098%)',
  '450': 'hsl(234.674556, 96.571429%, 65.686275%)',
  '500': 'hsl(226.632124, 97.969543%, 61.372549%)',
  '550': 'hsl(217.339056, 98.312236%, 53.529412%)',
  '600': 'hsl(207.764706, 100%, 50%)',
  '650': 'hsl(202.962963, 100%, 52.352941%)',
  '700': 'hsl(201.428571, 100%, 61.568627%)',
  '750': 'hsl(199.354839, 100%, 69.607843%)',
  '800': 'hsl(196.173913, 100%, 77.45098%)',
  '850': 'hsl(196.633663, 100%, 80.196078%)',
  '900': 'hsl(197.727273, 100%, 82.745098%)',
  '950': 'hsl(197.6, 97.402597%, 84.901961%)',
  '1000': 'hsl(199.047619, 96.923077%, 87.254902%)',
  '1050': 'hsl(199.2, 92.592593%, 89.411765%)',
}
export const deepCurrent = {
  '50': 'hsl(188, 73.170732%, 16.078431%)',
  '100': 'hsl(188.181818, 64.705882%, 20%)',
  '150': 'hsl(188.219178, 59.349593%, 24.117647%)',
  '200': 'hsl(188.888889, 55.862069%, 28.431373%)',
  '250': 'hsl(188.863636, 53.012048%, 32.54902%)',
  '300': 'hsl(188.75, 51.06383%, 36.862745%)',
  '350': 'hsl(191.851852, 100%, 31.764706%)',
  '400': 'hsl(197.608696, 100%, 36.078431%)',
  '450': 'hsl(203.653846, 100%, 40.784314%)',
  '500': 'hsl(209.090909, 100%, 45.294118%)',
  '550': 'hsl(217.339056, 98.312236%, 53.529412%)',
  '600': 'hsl(207.764706, 100%, 50%)',
  '650': 'hsl(202.962963, 100%, 52.352941%)',
  '700': 'hsl(201.428571, 100%, 61.568627%)',
  '750': 'hsl(199.354839, 100%, 69.607843%)',
  '800': 'hsl(196.173913, 100%, 77.45098%)',
  '850': 'hsl(196.633663, 100%, 80.196078%)',
  '900': 'hsl(197.727273, 100%, 82.745098%)',
  '950': 'hsl(197.6, 97.402597%, 84.901961%)',
  '1000': 'hsl(199.047619, 96.923077%, 87.254902%)',
  '1050': 'hsl(199.2, 92.592593%, 89.411765%)',
}
export const blueRed = {
  '50': 'hsl(217.2, 100%, 19.607843%)',
  '100': 'hsl(216.377953, 98.449612%, 25.294118%)',
  '150': 'hsl(216, 96.273292%, 31.568627%)',
  '200': 'hsl(216.263736, 92.857143%, 38.431373%)',
  '250': 'hsl(216.811594, 88.841202%, 45.686275%)',
  '300': 'hsl(217.339056, 98.312236%, 53.529412%)',
  '350': 'hsl(217.877095, 100%, 64.901961%)',
  '400': 'hsl(217.164179, 100%, 73.72549%)',
  '450': 'hsl(216.666667, 100%, 82.352941%)',
  '500': 'hsl(216, 100%, 91.176471%)',
  '550': 'hsl(1.5, 95.238095%, 91.764706%)',
  '600': 'hsl(0.8, 86.206897%, 82.941176%)',
  '650': 'hsl(359.439252, 79.259259%, 73.529412%)',
  '700': 'hsl(356.571429, 72.916667%, 62.352941%)',
  '750': 'hsl(348.556701, 82.20339%, 46.27451%)',
  '800': 'hsl(347.386364, 85.436893%, 40.392157%)',
  '850': 'hsl(346.624204, 88.700565%, 34.705882%)',
  '900': 'hsl(345.217391, 93.243243%, 29.019608%)',
  '950': 'hsl(344.87395, 96.747967%, 24.117647%)',
  '1000': 'hsl(344.848485, 100%, 19.411765%)',
}
export const blueOrange = {
  '50': 'hsl(217.2, 100%, 19.607843%)',
  '100': 'hsl(216.377953, 98.449612%, 25.294118%)',
  '150': 'hsl(216, 96.273292%, 31.568627%)',
  '200': 'hsl(216.263736, 92.857143%, 38.431373%)',
  '250': 'hsl(216.811594, 88.841202%, 45.686275%)',
  '300': 'hsl(217.339056, 98.312236%, 53.529412%)',
  '350': 'hsl(217.877095, 100%, 64.901961%)',
  '400': 'hsl(217.164179, 100%, 73.72549%)',
  '450': 'hsl(216.666667, 100%, 82.352941%)',
  '500': 'hsl(216, 100%, 91.176471%)',
  '550': 'hsl(17.560976, 100%, 91.960784%)',
  '600': 'hsl(16.829268, 100%, 83.921569%)',
  '650': 'hsl(17.073171, 98.4%, 75.490196%)',
  '700': 'hsl(17.300613, 94.219653%, 66.078431%)',
  '750': 'hsl(20, 90%, 52.941176%)',
  '800': 'hsl(18.712871, 82.113821%, 48.235294%)',
  '850': 'hsl(17.005348, 84.615385%, 43.333333%)',
  '900': 'hsl(15.517241, 88.77551%, 38.431373%)',
  '950': 'hsl(13.703704, 94.186047%, 33.72549%)',
  '1000': 'hsl(10.945946, 100%, 29.019608%)',
}
export const purpleYellow = {
  '50': 'hsl(272.210526, 73.643411%, 25.294118%)',
  '100': 'hsl(268.867925, 63.855422%, 32.54902%)',
  '150': 'hsl(265.423729, 57.843137%, 40%)',
  '200': 'hsl(262.615385, 53.278689%, 47.843137%)',
  '250': 'hsl(259.583333, 63.716814%, 55.686275%)',
  '300': 'hsl(256.538462, 84.782609%, 63.921569%)',
  '350': 'hsl(253.064516, 88.571429%, 72.54902%)',
  '400': 'hsl(250.322581, 92.079208%, 80.196078%)',
  '450': 'hsl(247.619048, 96.923077%, 87.254902%)',
  '500': 'hsl(247.5, 100%, 93.72549%)',
  '550': 'hsl(35.675676, 100%, 92.745098%)',
  '600': 'hsl(35.2, 100%, 85.294118%)',
  '650': 'hsl(36, 98.290598%, 77.058824%)',
  '700': 'hsl(37.358491, 96.363636%, 67.647059%)',
  '750': 'hsl(41.632653, 96.078431%, 50%)',
  '800': 'hsl(41.666667, 97.297297%, 43.529412%)',
  '850': 'hsl(41.71123, 97.905759%, 37.45098%)',
  '900': 'hsl(41.509434, 98.757764%, 31.568627%)',
  '950': 'hsl(41.363636, 100%, 25.882353%)',
  '1000': 'hsl(41.142857, 100%, 20.588235%)',
}
export const fuchsiaTeal = {
  '50': 'hsl(314.257426, 100%, 19.803922%)',
  '100': 'hsl(313.884298, 96.8%, 24.509804%)',
  '150': 'hsl(313.521127, 94.666667%, 29.411765%)',
  '200': 'hsl(313.416149, 90.960452%, 34.705882%)',
  '250': 'hsl(313.333333, 87.378641%, 40.392157%)',
  '300': 'hsl(312.964824, 84.680851%, 46.078431%)',
  '350': 'hsl(316.834532, 73.544974%, 62.941176%)',
  '400': 'hsl(319.038462, 77.61194%, 73.72549%)',
  '450': 'hsl(321.126761, 83.529412%, 83.333333%)',
  '500': 'hsl(322.702703, 90.243902%, 91.960784%)',
  '550': 'hsl(190, 28.125%, 87.45098%)',
  '600': 'hsl(190.285714, 27.559055%, 75.098039%)',
  '650': 'hsl(189.230769, 27.368421%, 62.745098%)',
  '700': 'hsl(189.295775, 28.063241%, 50.392157%)',
  '750': 'hsl(188.75, 51.06383%, 36.862745%)',
  '800': 'hsl(188.863636, 53.012048%, 32.54902%)',
  '850': 'hsl(188.888889, 55.862069%, 28.431373%)',
  '900': 'hsl(188.219178, 59.349593%, 24.117647%)',
  '950': 'hsl(188.181818, 64.705882%, 20%)',
  '1000': 'hsl(188, 73.170732%, 16.078431%)',
}
